import React, { useState, useEffect } from 'react';

const API = 'https://api.whatmarket.pixcovery.mx';

function formatPesos(num) {
  return '$' + Math.round(num).toLocaleString('es-MX');
}

function formatFecha(str) {
  if (!str) return '—';
  return new Date(str).toLocaleDateString('es-MX', { day:'2-digit', month:'short', year:'numeric' });
}

const S = {
  topbar:    { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:6 },
  breadcrumb:{ fontSize:12, color:'#7A8F89', marginBottom:16 },
  h1:        { fontSize:20, fontWeight:700, color:'#0D1F1A' },
  metrics:   { display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:12, marginBottom:20 },
  metric:    { background:'white', borderRadius:12, padding:14, border:'1px solid #E4EDE8' },
  mLbl:      { fontSize:11, color:'#7A8F89', marginBottom:6 },
  mVal:      { fontSize:22, fontWeight:800, color:'#0D1F1A' },
  mSub:      { fontSize:10, color:'#7A8F89', marginTop:3 },
  grid2:     { display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:16 },
  card:      { background:'white', borderRadius:12, border:'1px solid #E4EDE8' },
  cardHdr:   { padding:'12px 16px', borderBottom:'1px solid #E4EDE8', display:'flex', justifyContent:'space-between', alignItems:'center' },
  cardTitle: { fontSize:13, fontWeight:700, color:'#0D1F1A' },
  cardBody:  { padding:16 },
  barRow:    { display:'flex', alignItems:'center', gap:10, marginBottom:10 },
  barLabel:  { fontSize:12, color:'#7A8F89', width:160, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' },
  barTrack:  { flex:1, height:10, background:'#F0F4F0', borderRadius:5, overflow:'hidden' },
  barFill:   { height:'100%', borderRadius:5, background:'#075E54' },
  barAmt:    { fontSize:12, fontWeight:700, color:'#0D1F1A', minWidth:70, textAlign:'right' },
  table:     { width:'100%', borderCollapse:'collapse', fontSize:12 },
  th:        { padding:'9px 12px', textAlign:'left', fontSize:11, fontWeight:700, color:'#7A8F89', borderBottom:'1px solid #E4EDE8', background:'#F0F4F0' },
  td:        { padding:'10px 12px', borderBottom:'1px solid #E4EDE8', color:'#0D1F1A' },
  badge:     { display:'inline-block', padding:'2px 8px', borderRadius:20, fontSize:11, fontWeight:600 },
  subdom:    { fontSize:11, color:'#7A8F89' },
  subdomSpan:{ color:'#075E54', fontWeight:600 },
  cargando:  { textAlign:'center', padding:40, color:'#7A8F89', fontSize:13 },
  statRow:   { display:'flex', justifyContent:'space-between', padding:'7px 0', borderBottom:'1px solid #E4EDE8', fontSize:12 },
  tabs:      { display:'flex', borderBottom:'1px solid #E4EDE8', marginBottom:20 },
  tab:       { padding:'10px 20px', fontSize:13, color:'#7A8F89', cursor:'pointer', border:'none', background:'none', fontFamily:'inherit', borderBottom:'2px solid transparent' },
  tabActive: { color:'#075E54', fontWeight:700, borderBottom:'2px solid #075E54' },
};

export default function ProductosVendidos({ tabInicial = 'ingresos' }) {
  const [tab, setTab] = useState(tabInicial);
  const [tiendas,       setTiendas]       = useState([]);
  const [planes,        setPlanes]        = useState([]);
  const [suscripciones, setSuscripciones] = useState([]);
  const [cargando,      setCargando]      = useState(true);

  useEffect(() => { cargarDatos(); }, []);

  async function cargarDatos() {
    try {
      setCargando(true);
      const [rTiendas, rPlanes, rSus] = await Promise.all([
        fetch(`${API}/admin/tiendas`).then(r => r.json()),
        fetch(`${API}/admin/planes`).then(r => r.json()),
        fetch(`${API}/admin/suscripciones`).then(r => r.json()),
      ]);
      setTiendas(rTiendas);
      setPlanes(rPlanes);
      setSuscripciones(rSus);
    } catch (err) {
      console.error(err);
    } finally {
      setCargando(false);
    }
  }

  // ── Calcular métricas ──
  const susActivas = suscripciones.filter(s => s.estado === 'activo');
  const mrr        = susActivas.reduce((a, s) => a + parseFloat(s.monto || 0), 0);
  const totalIngresosHistorico = suscripciones.reduce((a, s) => a + parseFloat(s.monto || 0), 0);

  // Ingresos por tienda
  const ingresosPorTienda = tiendas.map(t => {
    const sus  = suscripciones.filter(s => s.tienda_id === t.id);
    const total = sus.reduce((a, s) => a + parseFloat(s.monto || 0), 0);
    const plan  = planes.find(p => p.id === t.plan_id);
    const comision = susActivas.filter(s => s.tienda_id === t.id).reduce((a, s) => a + parseFloat(s.monto||0) * parseFloat(plan?.comision||0) / 100, 0);
    return { ...t, totalSus: total, comision, planNombre: plan?.nombre || 'Sin plan', planComision: parseFloat(plan?.comision||0) };
  }).sort((a, b) => b.totalSus - a.totalSus);

  const maxIngreso  = Math.max(...ingresosPorTienda.map(t => t.totalSus), 1);
  const maxComision = Math.max(...ingresosPorTienda.map(t => t.comision), 1);
  const totalComisiones = ingresosPorTienda.reduce((a, t) => a + t.comision, 0);

  // Distribución de planes
  const distPlanes = planes.map(p => ({
    ...p,
    count:    tiendas.filter(t => t.plan_id === p.id).length,
    ingresos: susActivas.filter(s => tiendas.find(t => t.id === s.tienda_id && t.plan_id === p.id)).reduce((a, s) => a + parseFloat(s.monto||0), 0),
  }));

  if (cargando) return <div style={S.cargando}>Cargando reportes...</div>;

  return (
    <div>
      <div style={S.topbar}>
        <div>
          <div style={S.breadcrumb}>Reportes</div>
          <h1 style={S.h1}>Reportes</h1>
        </div>
        <button style={{ padding:'6px 14px', borderRadius:8, border:'1px solid #E4EDE8', background:'white', fontSize:12, color:'#7A8F89', cursor:'pointer', fontFamily:'inherit' }} onClick={cargarDatos}>↻ Actualizar</button>
      </div>

      {/* Tabs */}
      <div style={S.tabs}>
        <button style={{ ...S.tab, ...(tab==='ingresos'   ? S.tabActive : {}) }} onClick={() => setTab('ingresos')}>💰 Ingresos</button>
        <button style={{ ...S.tab, ...(tab==='comisiones' ? S.tabActive : {}) }} onClick={() => setTab('comisiones')}>📊 Comisiones</button>
        <button style={{ ...S.tab, ...(tab==='planes'     ? S.tabActive : {}) }} onClick={() => setTab('planes')}>📦 Planes</button>
        <button style={{ ...S.tab, ...(tab==='suscripciones' ? S.tabActive : {}) }} onClick={() => setTab('suscripciones')}>🧾 Suscripciones</button>
      </div>

      {/* ── TAB INGRESOS ── */}
      {tab === 'ingresos' && (
        <>
          <div style={S.metrics}>
            <div style={S.metric}><div style={S.mLbl}>MRR actual</div><div style={{ ...S.mVal, color:'#075E54' }}>{formatPesos(mrr)}</div><div style={S.mSub}>Suscripciones activas</div></div>
            <div style={S.metric}><div style={S.mLbl}>Ingresos históricos</div><div style={S.mVal}>{formatPesos(totalIngresosHistorico)}</div><div style={S.mSub}>Todos los pagos</div></div>
            <div style={S.metric}><div style={S.mLbl}>Comisiones totales</div><div style={{ ...S.mVal, color:'#075E54' }}>{formatPesos(totalComisiones)}</div><div style={S.mSub}>Sobre ventas activas</div></div>
            <div style={S.metric}><div style={S.mLbl}>Tiendas activas</div><div style={S.mVal}>{tiendas.filter(t=>t.estado==='activo').length}</div><div style={S.mSub}>De {tiendas.length} registradas</div></div>
          </div>

          <div style={S.grid2}>
            <div style={S.card}>
              <div style={S.cardHdr}><div style={S.cardTitle}>Ingresos por suscripción — por tienda</div></div>
              <div style={S.cardBody}>
                {ingresosPorTienda.filter(t => t.totalSus > 0).map((t, i) => (
                  <div key={i} style={S.barRow}>
                    <div style={S.barLabel}>{t.nombre}</div>
                    <div style={S.barTrack}><div style={{ ...S.barFill, width:`${(t.totalSus/maxIngreso)*100}%` }} /></div>
                    <div style={S.barAmt}>{formatPesos(t.totalSus)}</div>
                  </div>
                ))}
                {ingresosPorTienda.every(t => t.totalSus === 0) && <div style={{ fontSize:12, color:'#7A8F89' }}>Sin ingresos registrados aún</div>}
              </div>
            </div>

            <div style={S.card}>
              <div style={S.cardHdr}><div style={S.cardTitle}>Distribución MRR por plan</div></div>
              <div style={S.cardBody}>
                {distPlanes.map(p => (
                  <div key={p.id} style={S.statRow}>
                    <span style={{ color:'#7A8F89' }}>Plan {p.nombre}</span>
                    <span style={{ fontWeight:700 }}>{formatPesos(p.ingresos)}<span style={{ fontSize:10, color:'#7A8F89', marginLeft:4 }}>({p.count} tiendas)</span></span>
                  </div>
                ))}
                <div style={{ ...S.statRow, borderBottom:'none', paddingTop:10, marginTop:4, borderTop:'1px solid #E4EDE8' }}>
                  <span style={{ fontWeight:700 }}>Total MRR</span>
                  <span style={{ fontWeight:700, color:'#075E54' }}>{formatPesos(mrr)}</span>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* ── TAB COMISIONES ── */}
      {tab === 'comisiones' && (
        <>
          <div style={S.metrics}>
            <div style={S.metric}><div style={S.mLbl}>Total comisiones</div><div style={{ ...S.mVal, color:'#075E54' }}>{formatPesos(totalComisiones)}</div><div style={S.mSub}>Sobre suscripciones activas</div></div>
            <div style={S.metric}><div style={S.mLbl}>Tiendas con comisión</div><div style={S.mVal}>{ingresosPorTienda.filter(t=>t.comision>0).length}</div><div style={S.mSub}>Planes con % de comisión</div></div>
            <div style={S.metric}><div style={S.mLbl}>Sin comisión</div><div style={S.mVal}>{ingresosPorTienda.filter(t=>t.planComision===0).length}</div><div style={S.mSub}>Plan Gratis</div></div>
            <div style={S.metric}><div style={S.mLbl}>Promedio por tienda</div><div style={S.mVal}>{ingresosPorTienda.filter(t=>t.comision>0).length > 0 ? formatPesos(totalComisiones / ingresosPorTienda.filter(t=>t.comision>0).length) : '$0'}</div><div style={S.mSub}>Tiendas activas</div></div>
          </div>

          <div style={S.card}>
            <div style={S.cardHdr}>
              <div style={S.cardTitle}>Comisiones por tienda</div>
              <span style={{ fontSize:13, color:'#075E54', fontWeight:700 }}>{formatPesos(totalComisiones)}</span>
            </div>
            <div style={S.cardBody}>
              {ingresosPorTienda.filter(t => t.comision > 0).map((t, i) => (
                <div key={i} style={S.barRow}>
                  <div style={S.barLabel}>{t.nombre}</div>
                  <div style={S.barTrack}><div style={{ ...S.barFill, width:`${(t.comision/maxComision)*100}%` }} /></div>
                  <div style={S.barAmt}>{formatPesos(t.comision)}</div>
                </div>
              ))}
              {ingresosPorTienda.every(t => t.comision === 0) && <div style={{ fontSize:12, color:'#7A8F89' }}>Sin comisiones registradas aún</div>}
              <div style={{ paddingTop:10, marginTop:4, borderTop:'1px solid #E4EDE8', fontSize:11, color:'#7A8F89' }}>
                {ingresosPorTienda.filter(t=>t.planComision===0).length} tiendas en plan Gratis — sin comisión
              </div>
            </div>
          </div>

          <div style={{ ...S.card, marginTop:16 }}>
            <div style={S.cardHdr}><div style={S.cardTitle}>Detalle de comisiones</div></div>
            <table style={S.table}>
              <thead>
                <tr>
                  <th style={S.th}>Tienda</th>
                  <th style={S.th}>Plan</th>
                  <th style={S.th}>% Comisión</th>
                  <th style={S.th}>Suscripción</th>
                  <th style={S.th}>Comisión estimada</th>
                </tr>
              </thead>
              <tbody>
                {ingresosPorTienda.map((t, i) => (
                  <tr key={i}>
                    <td style={S.td}>
                      <div style={{ fontWeight:700 }}>{t.nombre}</div>
                      <div style={S.subdom}><span style={S.subdomSpan}>{t.subdominio}</span>.whatmarket.com</div>
                    </td>
                    <td style={S.td}>{t.planNombre}</td>
                    <td style={S.td}>{t.planComision}%</td>
                    <td style={{ ...S.td, color:'#075E54', fontWeight:700 }}>{formatPesos(t.totalSus)}</td>
                    <td style={{ ...S.td, color: t.comision>0?'#075E54':'#7A8F89', fontWeight: t.comision>0?700:400 }}>{formatPesos(t.comision)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* ── TAB PLANES ── */}
      {tab === 'planes' && (
        <>
          <div style={S.metrics}>
            <div style={S.metric}><div style={S.mLbl}>Planes activos</div><div style={S.mVal}>{planes.filter(p=>p.activo).length}</div><div style={S.mSub}>De {planes.length} totales</div></div>
            <div style={S.metric}><div style={S.mLbl}>Plan más popular</div><div style={{ ...S.mVal, fontSize:16 }}>{distPlanes.sort((a,b)=>b.count-a.count)[0]?.nombre || '—'}</div><div style={S.mSub}>{distPlanes.sort((a,b)=>b.count-a.count)[0]?.count || 0} tiendas</div></div>
            <div style={S.metric}><div style={S.mLbl}>Tiendas en prueba</div><div style={{ ...S.mVal, color:'#E65100' }}>{tiendas.filter(t=>t.estado==='prueba').length}</div><div style={S.mSub}>Sin pago registrado</div></div>
            <div style={S.metric}><div style={S.mLbl}>MRR potencial</div><div style={S.mVal}>{formatPesos(distPlanes.reduce((a,p)=>a+(p.count*parseFloat(p.precio||0)),0))}</div><div style={S.mSub}>Si todos pagan</div></div>
          </div>

          <div style={S.card}>
            <div style={S.cardHdr}><div style={S.cardTitle}>Distribución de tiendas por plan</div></div>
            <table style={S.table}>
              <thead>
                <tr>
                  <th style={S.th}>Plan</th>
                  <th style={S.th}>Precio/mes</th>
                  <th style={S.th}>Comisión</th>
                  <th style={S.th}>Tiendas</th>
                  <th style={S.th}>MRR aportado</th>
                  <th style={S.th}>Estado</th>
                </tr>
              </thead>
              <tbody>
                {distPlanes.map((p, i) => (
                  <tr key={i}>
                    <td style={{ ...S.td, fontWeight:700 }}>{p.nombre}</td>
                    <td style={S.td}>{Number(p.precio)===0 ? 'Sin costo' : formatPesos(p.precio)}</td>
                    <td style={S.td}>{p.comision}%</td>
                    <td style={S.td}>{p.count}</td>
                    <td style={{ ...S.td, color:'#075E54', fontWeight:700 }}>{formatPesos(p.ingresos)}</td>
                    <td style={S.td}><span style={{ ...S.badge, background: p.activo?'#E1F5EE':'#F0F4F0', color: p.activo?'#085041':'#7A8F89' }}>{p.activo?'Activo':'Inactivo'}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* ── TAB SUSCRIPCIONES ── */}
      {tab === 'suscripciones' && (
        <>
          <div style={S.metrics}>
            <div style={S.metric}><div style={S.mLbl}>Total pagos</div><div style={S.mVal}>{suscripciones.length}</div><div style={S.mSub}>Histórico completo</div></div>
            <div style={S.metric}><div style={S.mLbl}>Activas</div><div style={{ ...S.mVal, color:'#085041' }}>{susActivas.length}</div><div style={S.mSub}>Al corriente</div></div>
            <div style={S.metric}><div style={S.mLbl}>Vencidas</div><div style={{ ...S.mVal, color:'#A32D2D' }}>{suscripciones.filter(s=>s.estado==='vencido').length}</div><div style={S.mSub}>Sin renovar</div></div>
            <div style={S.metric}><div style={S.mLbl}>Ingresos totales</div><div style={{ ...S.mVal, color:'#075E54' }}>{formatPesos(totalIngresosHistorico)}</div><div style={S.mSub}>Suma histórica</div></div>
          </div>

          <div style={S.card}>
            <div style={S.cardHdr}><div style={S.cardTitle}>Historial de suscripciones</div></div>
            <table style={S.table}>
              <thead>
                <tr>
                  <th style={S.th}>Tienda</th>
                  <th style={S.th}>Plan</th>
                  <th style={S.th}>Monto</th>
                  <th style={S.th}>Método</th>
                  <th style={S.th}>Vigencia</th>
                  <th style={S.th}>Estado</th>
                </tr>
              </thead>
              <tbody>
                {suscripciones.length === 0 && (
                  <tr><td colSpan={6} style={{ ...S.td, textAlign:'center', color:'#7A8F89', padding:32 }}>Sin suscripciones registradas</td></tr>
                )}
                {suscripciones.map((s, i) => (
                  <tr key={i}>
                    <td style={S.td}>
                      <div style={{ fontWeight:700 }}>{s.tienda_nombre}</div>
                      <div style={S.subdom}><span style={S.subdomSpan}>{s.subdominio}</span>.whatmarket.com</div>
                    </td>
                    <td style={S.td}>{s.plan_nombre}</td>
                    <td style={{ ...S.td, color:'#075E54', fontWeight:700 }}>{formatPesos(s.monto)}</td>
                    <td style={S.td}>{s.metodo_pago}</td>
                    <td style={S.td}><div style={{ fontSize:11 }}>{formatFecha(s.fecha_inicio)} →</div><div style={{ fontSize:11, fontWeight:700 }}>{formatFecha(s.fecha_fin)}</div></td>
                    <td style={S.td}><span style={{ ...S.badge, background: s.estado==='activo'?'#E1F5EE':s.estado==='vencido'?'#FCEBEB':'#F0F4F0', color: s.estado==='activo'?'#085041':s.estado==='vencido'?'#501313':'#7A8F89' }}>{s.estado}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}